import { render, staticRenderFns } from "./SegmentTemplatesModal.vue?vue&type=template&id=072c289c&"
import script from "./SegmentTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./SegmentTemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports